import {
  SET_CLEAN,
  SET_DIRTY,
  USER_AUTHENTICATED,
  SET_FLOW_SEARCH_TERM,
  SET_FIELD_SEARCH_TERM,
  SET_MAIN_MENU_PINNED,
  ALLOW_DEFAULT_PREF_USE,
  REQUEST_SAVE,
  ADD_TASK,
  COMPLETE_TASK,
  REMOVE_TASK
} from './mutation-types'

export default {
  [SET_CLEAN](state) {
    state.saveStateDirty = false
  },
  [SET_DIRTY](state) {
    state.saveStateDirty = true
  },
  [USER_AUTHENTICATED](state, username) {
    state.currentUser = username
  },
  [SET_FLOW_SEARCH_TERM](state, term) {
    state.flowSearchTerm = term
  },
  [SET_FIELD_SEARCH_TERM](state, term) {
    state.fieldSearchTerm = term
  },
  [SET_MAIN_MENU_PINNED](state, p) {
    state.mainMenuPinned = p
  },
  [ALLOW_DEFAULT_PREF_USE](state) {
    state.allowDefaultPrefUse = true
  },
  [REQUEST_SAVE](state) {
    state.savesRequested = state.savesRequested + 1
  },
  [ADD_TASK](state, task) {
    task.complete = false
    task.startMs = Date.now()
    state.pendingTasks.push(task)
  },
  [COMPLETE_TASK](state, task) {
    task.ms = Date.now() - task.startMs
    task.complete = true
  },
  [REMOVE_TASK](state, task) {
    const idx = state.pendingTasks.indexOf(task)
    if (idx >= 0) state.pendingTasks.splice(idx, 1)
  }
}
